export type RouteDataType = {
    controller?: string;
    action?: string;
    module?: string;
    type?: string;
    uri?: string;
    id?: string;
    redirect?: string;
};

/**
 * Get route data from window.location
 * @return {RouteDataType} initial data
 */
export const getRouterInfoFromWindow = (): RouteDataType => {
    const routeDataObject: RouteDataType = {
        action: 'index',
        controller: 'index',
        module: '',
        type: 'index',
        uri: __NODEJS__ ? '' : window.location.pathname,
    };

    const routeData = (__NODEJS__ ? '' : window.location.pathname).slice(1);
    const [module, type, action, , id] = routeData.split('/');

    const additionalFields: RouteDataType = {
        ...(action ? {action} : {}),
        ...(type ? {controller: type, type} : {}),
        ...(id ? {id} : {}),
        ...(module ? {module} : {}),
    };

    return {...routeDataObject, ...additionalFields};
};
